'use strict';

angular.module('enervexSalesappApp').factory('SimpleDuctData', function ($resource) {
	return $resource('/api/simple-duct-data/:id', {
		id: '@_id'
	},
	{
		update: {
			method: 'PUT'
		}
	});
});
